import { BaseModule } from "./base.module";

export class BootstrapFormValidationModule extends BaseModule {
    debugMode = false;
    initialize(element = document) {
        // console.log('BootstrapFormValidationModule initialize');
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = element.querySelectorAll('.needs-validation')
        // Loop over them and prevent submission
        Array.from(forms).forEach(form => {
            let fields = form.querySelectorAll('.form-control, .form-select, .form-check-input');
            fields.forEach((field) => {
                field.addEventListener('change', (event) => {
                    // console.log('field changed', event);
                    this.checkMatchFields(form);
                    let invalidFields = field.parentElement.querySelectorAll('.form-control:invalid, .form-select:invalid, .form-check:invalid');
                    let validFields = field.parentElement.querySelectorAll('.form-control:valid, .form-select:valid, .form-check-input:valid');
                    this.parseFields(invalidFields, validFields, form);
                });
                field.addEventListener('blur', (event) => {
                    // console.log('field blur', event);
                    this.checkMatchFields(form);
                    let invalidFields = field.parentElement.querySelectorAll('.form-control:invalid, .form-select:invalid, .form-check:invalid');
                    let validFields = field.parentElement.querySelectorAll('.form-control:valid, .form-select:valid, .form-check-input:valid');
                    this.parseFields(invalidFields, validFields, form);
                    // form.classList.add('was-validated');
                });
                field.addEventListener('keyup', (event) => {
                    this.checkMatchFields(form);
                    let invalidFields = field.parentElement.querySelectorAll('.form-control:invalid, .form-select:invalid, .form-check:invalid, .form-check:valid');
                    let validFields = field.parentElement.querySelectorAll('.form-control:valid, .form-select:valid, .form-check-input:valid, .form-check:valid');
                    this.parseFields(invalidFields, validFields, form);
                    // form.classList.add('was-validated');
                });
            });
            form.addEventListener('submit', (event) => {
                //     // console.log('form validity', form.checkValidity(), form.reportValidity());
                //     // event.preventDefault();
                //     // event.stopPropagation();
                this.onSubmit(event, form);
            }, false);
        });
        document.addEventListener('navigation-bar-height', (event) => {
            this.cacheNavBarHeight(event)
        });
    }

    cacheNavBarHeight(event) {
        // console.log('cacheNavBarHeight', event);
        this.navBarHeight = event.data;
    }
    checkMatchFields(form) {
        const matchFields = form.querySelectorAll('input[data-match]');
        Array.from(matchFields).forEach((field) => {
            const matchField = form.querySelector(`input[name="${field.dataset.match}"]`);
            if (field.value !== matchField.value) {
                field.setCustomValidity('E-mail adressen zijn niet hetzelfde');
                matchField.setCustomValidity('E-mail adressen zijn niet hetzelfde');
            } else {
                field.setCustomValidity('');
                matchField.setCustomValidity('');
            }
        });
    }
    /**
     *
     * @param {Event} event
     * @param {HTMLFormElement} form
     */
    onSubmit = (event, form) => {
        console.log('onSubmit' , event);
        let invalidFields = form.querySelectorAll('.form-control:invalid, .form-select:invalid, .form-check-:invalid');
        let validFields = form.querySelectorAll('.form-control:valid, .form-select:valid, .form-check-:valid');
        this.parseFields(invalidFields, validFields, form, true);
        form.classList.add('was-validated');
        if (invalidFields.length === 0) {
            const validEvent = new CustomEvent("form-validated", {
                bubbles: true,
                detail: { form }
            });
            form.dispatchEvent(validEvent);

            // let formControls = form.querySelectorAll('.form-control');
            // if (formControls) {
            //     formControls.forEach((formControl) => {
            //         // formControl.setAttribute('readonly', '');
            //         // formControl.classList.add('form-control-plaintext');
            //         // formControl.classList.remove('form-control');
            //     });
            // }
            let sucessFeedbackElement = form.parentElement.querySelector('.form-success-feedback');
            if (sucessFeedbackElement) {
                sucessFeedbackElement.classList.remove('d-none');
                sucessFeedbackElement.classList.add('d-block');
                form.classList.add('d-none');
            }
        } else {
            if (invalidFields.length > 0) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        // event.preventDefault();
        // event.stopPropagation();
    }
    parseFields(invalidFields, validFields, form, doSubmitIfValid = false) {
        if (
            this.debugMode === true
        ) {
            console.log('invalidFields', invalidFields);
        }
        if (invalidFields) {
            invalidFields.forEach((invalidField, index) => {
                if (index === 0) {
                    console.log('first invalid field offset top', invalidFields[index].offsetTop, invalidFields[index].getBoundingClientRect().top, document.documentElement.scrollTop , (document.documentElement.scrollTop + invalidFields[index].getBoundingClientRect().top));
                    console.log('current nav bar height', this.navBarHeight);
                    if (document && document.documentElement && this.navBarHeight) {
                        // window.scrollTo({
                        //     top: (document.documentElement.scrollTop + invalidFields[index].getBoundingClientRect().top) - this.navBarHeight - 20
                        //     // top: invalidFields[index].getBoundingClientRect().top
                        // });
                    }
                }
                let id = invalidField.getAttribute('id');
                let label = form.querySelector('label[for="' + id + '"]');
                if (label) {
                    label.classList.remove('custom-is-valid');
                    label.classList.add('custom-is-invalid');
                } else {
                    console.warn('no expected label found for invalid field with id', id);
                }
            });
            if (invalidFields.length > 0) {
                if (document) {
                    this.triggerEventOnElement(
                        'nexus.form.fields.invalid',
                        document,
                        {
                            form: form,
                            invalidFields: invalidFields,
                            validFields: validFields,
                        }
                    );
                }
            }
        }
        if (
            this.debugMode === true
        ) {
            console.log('validFields', validFields);
        }
        if (validFields) {
            validFields.forEach((validField) => {
                let id = validField.getAttribute('id');
                let label = form.querySelector('label[for="' + id + '"]');
                if (label) {
                    label.classList.remove('custom-is-invalid');
                    label.classList.add('custom-is-valid');
                } else {
                    console.warn('no expected label found for valid field with id', id);
                }
            });
        }
    }
}